export const containsSpecialChars = (password) => {
    const specialChars = /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/;
    return specialChars.test(password);
  };
  
 